/* The enquiry form on a page. The port's own script: on a page that carries the form, the header's Get a quote goes to it,
   as the review files' own pages with the form have it (the header is one section for every page, so it cannot know).
   Copied into assets by tools/build-assets.mjs. */
(function () {
  var form = document.querySelector('[data-ti-enquiry]');
  if (!form || !form.id) return;
  [].forEach.call(document.querySelectorAll('.ti-hdr__cta'), function (a) { a.setAttribute('href', '#' + form.id); });
})();
